import Link from 'next/link';
import styles from './privacyPolicyComponent.module.scss';

const PrivacyPolicyComponent = () => {
  return (
    <section className="container">
      <div className={styles.privacyPolicyContainer}>
        <div className={styles.privacyPolicyBlock}>
          <p className={styles.privacyPolicyText}>
            {/* <b>Last Updated: June 2026</b> */}
          </p>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Introduction</h4>
          <div className={styles.privacyPolicyText}>
            Hera Flight (&quot;Hera Flight&quot;, &quot;we&quot;,
            &quot;our&quot;, or &quot;us&quot;) respects your privacy and is
            committed to protecting the personal information you share with us.
            This Privacy Policy explains how we collect, use, store, and
            disclose information when you visit our website, submit forms,
            contact us, or otherwise interact with our services.
            <br />
            <br />
            By using our website or submitting information to us, you agree to
            the practices described in this Privacy Policy.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Information We Collect</h4>
          <div className={styles.privacyPolicyText}>
            We may collect personal information that you voluntarily provide,
            including:
            <br />
            &bull; Full name
            <br />
            &bull; Email address
            <br />
            &bull; Phone number
            <br />
            &bull; Company name
            <br />
            &bull; Job title
            <br />
            &bull; Flight inquiry details
            <br />
            &bull; Charter requirements
            <br />
            &bull; Any information submitted through contact forms, lead forms,
            email communications, or other interactions with us
            <br />
            <br />
            We may also collect certain technical information automatically when
            you visit our website, including:
            <br />
            &bull; IP address
            <br />
            &bull; Browser type
            <br />
            &bull; Device information
            <br />
            &bull; Operating system
            <br />
            &bull; Referring website
            <br />
            &bull; Website usage and analytics data
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>
            How We Use Your Information
          </h4>
          <div className={styles.privacyPolicyText}>
            We may use collected information to:
            <br />
            &bull; Respond to inquiries and requests
            <br />
            &bull; Provide information about our services
            <br />
            &bull; Process charter and aviation-related requests
            <br />
            &bull; Schedule consultations, demonstrations, or meetings
            <br />
            &bull; Communicate with prospective and existing customers
            <br />
            &bull; Improve our website, services, and user experience
            <br />
            &bull; Conduct internal business operations and analytics
            <br />
            &bull; Comply with legal obligations
            <br />
            &bull; Protect our rights, property, and security
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>
            LinkedIn Lead Generation Forms
          </h4>
          <div className={styles.privacyPolicyText}>
            When you submit information through a LinkedIn Lead Generation Form
            associated with Hera Flight, we may receive information directly
            from LinkedIn, including:
            <br />
            &bull; Name
            <br />
            &bull; Email address
            <br />
            &bull; Phone number
            <br />
            &bull; Company name
            <br />
            &bull; Job title
            <br />
            &bull; Other information included in the form
            <br />
            <br />
            This information is used to respond to your inquiry, provide
            requested information, communicate regarding our services, and
            maintain records of business communications.
            <br />
            <br />
            Information collected through LinkedIn Lead Generation Forms is also
            subject to LinkedIn&apos;s Privacy Policy (
            <Link
              href="https://www.linkedin.com/legal/privacy-policy"
              className={styles.privacyPolicyLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              linkedin.com/legal/privacy-policy
            </Link>
            ).
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Information Sharing</h4>
          <div className={styles.privacyPolicyText}>
            We do not sell personal information.
            <br />
            <br />
            We may share information with trusted service providers,
            contractors, software platforms, CRM systems, marketing platforms,
            hosting providers, analytics providers, and other vendors that help
            us operate our business and provide services.
            <br />
            <br />
            Information may also be disclosed when required by law, regulation,
            legal process, or governmental request.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Data Retention</h4>
          <div className={styles.privacyPolicyText}>
            We retain personal information for as long as reasonably necessary
            to fulfill the purposes described in this Privacy Policy, comply
            with legal obligations, resolve disputes, and enforce agreements.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Cookies and Analytics</h4>
          <div className={styles.privacyPolicyText}>
            Our website may use cookies and similar technologies to improve user
            experience, analyze website performance, and understand visitor
            behavior.
            <br />
            <br />
            You may control cookie settings through your browser preferences.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Data Security</h4>
          <div className={styles.privacyPolicyText}>
            We implement reasonable administrative, technical, and
            organizational measures designed to protect personal information
            against unauthorized access, disclosure, alteration, or destruction.
            <br />
            <br />
            However, no method of electronic transmission or storage can be
            guaranteed to be completely secure.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Your Rights</h4>
          <div className={styles.privacyPolicyText}>
            Depending on applicable law, you may have the right to:
            <br />
            &bull; Request access to your personal information
            <br />
            &bull; Request correction of inaccurate information
            <br />
            &bull; Request deletion of your personal information
            <br />
            &bull; Object to certain processing activities
            <br />
            &bull; Withdraw consent where applicable
            <br />
            <br />
            To exercise these rights, please contact us using the contact
            information available on our website.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Third-Party Websites</h4>
          <div className={styles.privacyPolicyText}>
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices, content, or policies of
            third-party websites.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>
            Changes to This Privacy Policy
          </h4>
          <div className={styles.privacyPolicyText}>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated revision date.
          </div>
        </div>

        <div className={styles.privacyPolicyBlock}>
          <h4 className={styles.privacyPolicyTitle}>Contact Information</h4>
          <div className={styles.privacyPolicyText}>
            If you have questions regarding this Privacy Policy or our handling
            of personal information, please contact Hera Flight through the{' '}
            <Link href="/contact" className={styles.privacyPolicyLink}>
              contact information
            </Link>{' '}
            provided on our website.
            <br />
            <br />
            By using this website or submitting information through our forms,
            you acknowledge that you have read and understood this Privacy
            Policy.
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyComponent;
